import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-base font-semibold transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-(--app-status-danger-foreground)/25 dark:aria-invalid:ring-(--app-status-danger-foreground)/40 aria-invalid:border-(--app-status-danger-foreground)",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90 shadow-cta",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        marketing: "bg-basic-black text-inverse hover:bg-basic-black/90 shadow-cta",
      },
      size: {
        default: "rounded-full px-4 py-3 has-[>svg]:px-3",
        sm: "rounded-full gap-1.5 px-3 py-2 has-[>svg]:px-2.5",
        lg: "rounded-full px-6 py-4 has-[>svg]:px-4",
        icon: "size-9",
        "icon-sm": "size-8",
        "icon-lg": "size-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);
